import { t, translate } from "../I18n";
/**
 * Deliberately reuses the same `payment_method.*` keys as Pendolino's
 * `PaymentMethod#label`, so server- and client-rendered lists read identically.
 */
export function paymentMethodLabel(method) {
    switch (method) {
        case "Cash":
            return translate(t.payment_method.cash.label);
        case "Card":
            return translate(t.payment_method.card.label);
        case "Online":
            return translate(t.payment_method.online.label);
        case "BankTransfer":
            return translate(t.payment_method.bank_transfer.label);
        case "CashAndCard":
            return translate(t.payment_method.online.cashAndCard);
        case "Offline":
            return translate(t.payment_method.online.offline);
        case "Prepaid":
            return translate(t.payment_method.prepaid.description);
    }
}
